import { ColumnKey, PartnerChannelFormValues } from "./types";
import * as Yup from "yup";

export const apiEndpoint = `/partner-channels`;

export const ColumnOptions: { value: ColumnKey; label: string }[] = [
  { value: "channelId", label: "Channel ID" },
  { value: "channelName", label: "Channel Name" },
  { value: "subChannel", label: "Sub Channel " },
  { value: "mainChannel", label: "Main Channel " },
  { value: "ggsChannel", label: "GGS Channel " },
];

export const DefaultHiddenColumns: ColumnKey[] = ["channelId", "updateTstamp"];

export const AllowedSortFields = [
  "channelName",
  "subChannel",
  "mainChannel",
  "updateTstamp",
] as const;

export const PartnerChannelFormInitialValues: PartnerChannelFormValues = {
  channelName: "",
  subChannel: "",
  mainChannel: "",
  ggsChannel: "",
};

export const PartnerChannelValidationSchema = Yup.object({
  channelName: Yup.string().trim().required("Channel Name is required"),
  subChannel: Yup.string().trim().required("Sub Channel is required"),
  mainChannel: Yup.string().trim().required("Main Channel is required"),
  ggsChannel: Yup.string().trim().required("GGS Channel is required"),
});

export const PartnerChannelFormFields = [
  { name: "channelName", label: "Channel Name", type: "text" },
  { name: "subChannel", label: "Sub Channel", type: "text" },
  { name: "mainChannel", label: "Main Channel", type: "text" },
  { name: "ggsChannel", label: "GGS Channel", type: "text" },
];
